function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "squiggle2_gradient",
  y1: 13.84,
  x2: 159.78,
  y2: 13.84,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#20c4f4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.12,
  stopColor: "#23bff2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.27,
  stopColor: "#2cb0ee"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#3a97e6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6,
  stopColor: "#4f74dc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#6947ce"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.96,
  stopColor: "#8812be"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8f06ba"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_6",
  "data-name": "Layer 6"
}, /*#__PURE__*/React.createElement("path", {
  className: "animate-me",
  d: "M3,5.59s85.34-6.26,113.11.69L73.49,20.48s66.16-.29,83.29,4.2",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  stroke: "url(#squiggle2_gradient)"
}), /*#__PURE__*/React.createElement("path", {
  className: "svg-mask",
  fill: "none",
  d: "M91.7,17.57c6.49.08,13,.37,19.46.77Q121.51,19,131.84,20c5.93.6,11.87,1.29,17.75,2.25a39.36,39.36,0,0,1,8.72,2.11c.53.22,1.95,1,.7,1.17a11.48,11.48,0,0,1-2.55-.17c-3.16-.39-6.29-.87-9.46-1.15-4.25-.38-8.52-.64-12.78-.82-5-.2-10-.32-15.06-.39-5.26-.08-10.51-.1-15.76-.09q-7.43,0-14.85.11c-4.11.05-17.84.32-20.59.39-.86,0-2.6,0-2.6.07V34.6h97.48V17.09S91.7,17.59,91.7,17.57Z"
})));

var SvgSquiggle2 = function SvgSquiggle2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162.84,
    height: 34.6,
    viewBox: "0 0 162.84 34.6",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSquiggle2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/squiggle-2.48e514b8.svg";
export { ForwardRef as ReactComponent };